// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2cUVV","boxTitle":"Qualiphy_boxTitle__mCgSD","box":"Qualiphy_box__h1B_2","toggleWrap":"Qualiphy_toggleWrap__1FunQ"};